import { X } from "lucide-react"
import type { ReactNode } from "react"
import { cn } from "@/shared/lib/utils"
import { Button } from "@/shared/ui/button"

/** Removable filter/tag chip: a rounded label with a built-in remove button. */
export function FilterChip({
	children,
	onRemove,
	removeLabel = "Убрать фильтр",
	className,
}: {
	children: ReactNode
	onRemove: () => void
	removeLabel?: string
	className?: string
}) {
	return (
		<span
			className={cn(
				"inline-flex max-w-full items-center gap-1.5 rounded-full bg-secondary px-3 py-1 text-xs",
				className,
			)}
		>
			<span className="truncate">{children}</span>
			<Button
				type="button"
				variant="ghost"
				size="icon"
				aria-label={removeLabel}
				onClick={onRemove}
				className="h-4 w-4 text-muted-foreground hover:bg-transparent hover:text-foreground"
			>
				<X className="h-3.5 w-3.5" />
			</Button>
		</span>
	)
}
